import React from 'react';
import ReactDOM from 'react-dom';
import UserFacingLeaderboard from './components/UserFacingLeaderboard';
import NFRLeaderboard from './components/nfrleaderboard';
import { createUseStyles } from 'react-jss';
// index.js or App.js

const useStyles = createUseStyles({
  '@global': {
    '.MuiDataGrid-root .MuiDataGrid-cell:focus': {
      outline: 'none !important',
    },
    '.MuiDataGrid-root .MuiDataGrid-row:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
    },
    '.MuiDataGrid-root .MuiDataGrid-row.Mui-selected': {
      backgroundColor: 'rgba(0, 0, 0, 0.08) !important',
    },
    '.MuiDataGrid-root': {
      userSelect: 'none',
      WebkitUserSelect: 'none',
      MozUserSelect: 'none',
      msUserSelect: 'none',
    },
  },
});

const App = () => {
  useStyles();
  return <UserFacingLeaderboard />;
  // return <NFRLeaderboard />;
};

document.addEventListener('DOMContentLoaded', function() {
  const rootElement = document.getElementById('nfr-leaderboard-root');
  if (rootElement) {
    ReactDOM.render(<App />, rootElement);
  }
});
